loginRequired: Inicio de sesión requerido
loginRequiredMessage: Para servirle mejor, por favor inicie sesión primero
goToLogin: Ir a iniciar sesión
